import React, { useEffect, useRef, useState } from 'react';
import Button from './Button';

interface SubmitButtonProps {
  isSubmitting: boolean;
  block?: boolean;
}

function SubmitButton({ isSubmitting, block }: SubmitButtonProps): JSX.Element {
  // Server-rendered pages show the form before React attaches its submit
  // handler; a click then makes the browser submit the form itself, as a GET
  // that drops the file and puts every field in the URL. Enable on mount.
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => setIsMounted(true), []);

  // Disabling the form while it submits drops focus to the page. Note where
  // focus was as submitting starts (read before the disabling commit) and
  // return it there afterwards, unless the user has moved it since.
  const focusBeforeSubmit = useRef<Element | null>(null);
  if (isSubmitting && focusBeforeSubmit.current === null) {
    focusBeforeSubmit.current = document.activeElement;
  }
  useEffect(() => {
    if (isSubmitting) {
      return;
    }
    const previous = focusBeforeSubmit.current;
    focusBeforeSubmit.current = null;
    if (
      previous instanceof HTMLElement &&
      previous.isConnected &&
      document.activeElement === document.body
    ) {
      previous.focus();
    }
  }, [isSubmitting]);

  return (
    <Button
      bsStyle="primary"
      type="submit"
      disabled={isSubmitting || !isMounted}
      block={block}
    >
      Submit
      <span
        style={{
          marginLeft: 8,
          display: isSubmitting ? 'inline-block' : 'none',
        }}
      >
        <i className="fa fa-spinner fa-spin" />
        {` `}
      </span>
    </Button>
  );
}

export default SubmitButton;
